module.exports = __webpack_public_path__ + "static/media/imagem40.710e648a.jpeg";